<template>
   <h1 class="system_content_title">查询企业密码</h1>
    <div class="system_content_panels">
      <div class="systemPanel" style="position: relative; padding-bottom: 40px">
      <el-form-item>
        <el-input
        style="width:400px"
          v-model="state.searchInput"
          placeholder="请输入名称或信用代码查询"
          clearable
          @clear="getTableData"
        >
          <template #append>
            <el-button icon="Search" @click="getTableData" />
          </template>
        </el-input>
      </el-form-item>
    
    <el-table
      :data="state.tableData"
      stripe
      border
      v-loading="state.loading"
     style="min-height:70vh"
      table-layout="fixed"
    >
      <el-table-column type="index" width="50" />
      <el-table-column prop="name" label="企业名称" />
      <el-table-column prop="orgCode" label="信用代码" />
      <el-table-column prop="regionFullName" label="行政区域" />
      <el-table-column prop="registFromSys" label="注册来源" />
  
      <el-table-column  label="操作" >
		   <template #default="scope">               
                <el-button
                  size="small"
                  type="warning"
                  @click="showDetail(scope.row.id)"
                  style="margin-bottom: 2px;margin-right:2px"
                  >查看基本信息</el-button
                >			
		   </template>
	  </el-table-column>
    </el-table>
    </div>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="state.pageInfo.pageIndex"
      :page-sizes="[20, 50, 100, 200, 500, 1000]"
      :page-size="state.pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="state.pageInfo.totalRowCount"
      v-if="state.pageInfo.totalRowCount"
      class="pageinfo"
    >
    </el-pagination>
    <el-dialog
      v-model="state.addVisible"
      title="添加企业"
      width="30%"
      :before-close="handleClose"
    >

  请选择用户：
      <el-select
        v-model="state.addCompanyList"
        filterable
        remote
        multiple
        placeholder="输入名称或信用代码"
        :remote-method="searchUser"
        :loading="state.addSearchLoading"
        style="margin-bottom: 10px"
      >
        <el-option
          v-for="item in state.userList"
          :key="item.id"
          :label="item.name + ' - ' + item.orgCode"
          :value="item.id"
        />
      </el-select>
 
    
  
      <template #footer>
        <span class="dialog-footer" style="margin: 0 auto">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            @click="setUserRole"
            :disabled="!state.addUser || !state.role"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage } from "element-plus";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { DArrowLeft } from "@element-plus/icons-vue";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    // const roleId = router.currentRoute.value.query.roleId
    const state = reactive({
      tableData: [],
      loading: false,
      searchInput: "",
      pageInfo: {},
      addVisible: false,
      addSearch: "",
      addSearchLoading: false,
      roleList: [],
      userList: [],
      addUser: null,
      role: null,
      companySearchInput:"",
    });

    const getTableData = async () => {
      state.loading = true;
      const { data } = await api.companyApi.getGZCompanies({
        page: state.pageInfo.pageIndex || 1,
        rows: state.pageInfo.pageSize || 20,
        sort: "",
        value: state.searchInput,
        // intId: parseInt(roleId)
      });
      if (data.isSuccessful) {
        state.loading = false;
        state.tableData = data.resultObj.data;
        state.pageInfo = data.resultObj.pagerInfo;
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };
    getTableData();
  
   
   
	 const deleteItem = async (id) => {
      state.addSearchLoading = true;
      const { data } = await api.userApi.deleteUserRole(id);
      console.info("search user", data);
      if (data.isSuccessful) {
		 ElMessage({
          message: data.resultMsg,
          type: "success",
        });
       getTableData()
      }else{
		 ElMessage({
          message: data.resultMsg||"未知错误",
          type: "error",
		  grouping:true
        });
	  }
      state.addSearchLoading = false;
    };
    const handleClose = () => {
      state.addVisible = false;
      state.addSearch = "";
      state.addUser = "";
    };
   
  
    const showDetail =async (id)=>{
      

   
    const path = `/system/userTable/comInfo?cid=${id}`;
      const routerData = router.resolve(path);
      window.open(routerData.href, "_blank");
      return
    }
       
     
    return {
      state,
      getTableData,
      handleClose,
	  deleteItem,
    showDetail
    };
  },
  methods: {
    handleSizeChange(val) {
      this.state.pageInfo.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.state.pageInfo.pageIndex = val;
      this.getTableData();
    },
    getBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;

.el-input__inner {
  width: 100%;
}
</style>
